import React from 'react';
import './address-search-menu-item.css';

const AddressSearchMenuItem = ({ addressItem }) => (
  <div className="suggested-address-search-item">
    <span className="suggested-address">{addressItem.address}</span>
  </div>
);

export default AddressSearchMenuItem;
